
/**
 * 필드별 검증 에러
 */
export type ListConversations401ErrorsItem = {
  /** 에러가 발생한 필드명 */
  field: string;
  /** 필드별 에러 메시지 */
  message: string;
};
